<div class="product-file-export-configurations">
  <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-3">
    <h3 class="page-title mb-2 mb-md-0">{{ 'PFE_TITLE' | translate }}</h3>
    <div>
      <button type="button" class="btn btn-outline-secondary mr-2" (click)="loadConfigurations()" [disabled]="loading || saving">
        <i class="fa fa-refresh mr-1" aria-hidden="true"></i>
        {{ 'PFE_REFRESH' | translate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="newConfiguration()" [disabled]="loading || saving || isNew">
        <i class="fa fa-plus mr-1" aria-hidden="true"></i>
        {{ 'PFE_NEW_CONFIGURATION' | translate }}
      </button>
    </div>
  </div>

  <div *ngIf="loadError" class="alert alert-danger py-2" role="alert">
    {{ loadError }}
  </div>

  <div class="row">
    <div class="col-12 col-xl-4 mb-3 mb-xl-0">
      <div class="pfe-config-list border">
        <div class="pfe-config-list-header p-3 border-bottom">
          <label for="pfe-config-filter" class="small text-muted mb-1">{{ 'PFE_FILTER' | translate }}</label>
          <input
            #filterInput
            id="pfe-config-filter"
            type="text"
            class="form-control"
            [value]="filterText"
            (input)="onFilterTextChange(filterInput.value)"
            [placeholder]="'PFE_FILTER_PLACEHOLDER' | translate"
          />
        </div>

        <div class="table-responsive pfe-config-list-table">
          <table class="table table-hover table-sm mb-0">
            <thead>
              <tr>
                <th scope="col">{{ 'PFE_COLUMN_ID' | translate }}</th>
                <th scope="col">{{ 'PFE_COLUMN_ASSORTMENT' | translate }}</th>
                <th scope="col">{{ 'PFE_COLUMN_ACTIVE' | translate }}</th>
                <th scope="col">{{ 'PFE_COLUMN_FTP' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="loading">
                <td colspan="4" class="text-center py-4">
                  <i class="fa fa-spinner fa-spin mr-2" aria-hidden="true"></i>
                  {{ 'PFE_LOADING' | translate }}
                </td>
              </tr>
              <tr *ngIf="!loading && filteredConfigurations.length === 0">
                <td colspan="4" class="text-center text-muted py-4">{{ 'PFE_NO_CONFIGURATIONS_FOUND' | translate }}</td>
              </tr>
              <tr
                *ngFor="let configuration of filteredConfigurations; trackBy: trackByConfigurationId"
                class="pfe-config-row"
                [ngClass]="{ active: isSelected(configuration) }"
                (click)="selectConfiguration(configuration)"
              >
                <td>
                  <button type="button" class="btn btn-link btn-sm p-0 text-left">
                    {{ configuration.id || ('PFE_NEW' | translate) }}
                  </button>
                </td>
                <td>{{ configuration.assortmentId || '-' }}</td>
                <td>
                  <span class="badge" [ngClass]="configuration.active ? 'badge-success' : 'badge-secondary'">
                    {{ (configuration.active ? 'PFE_YES' : 'PFE_NO') | translate }}
                  </span>
                </td>
                <td>
                  <span class="badge" [ngClass]="configuration.sendToFtp ? 'badge-success' : 'badge-secondary'">
                    {{ (configuration.sendToFtp ? 'PFE_YES' : 'PFE_NO') | translate }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="col-12 col-xl-8">
      <div *ngIf="selectedConfiguration && form; else noSelection" class="pfe-config-editor border">
        <form [formGroup]="form" (ngSubmit)="save()">
          <div class="pfe-config-editor-header p-3 border-bottom">
            <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between">
              <div class="mb-2 mb-lg-0">
                <div class="small text-muted">{{ (isNew ? 'PFE_CREATING' : 'PFE_EDITING') | translate }}</div>
                <h4 class="mb-0">{{ isNew ? ('PFE_NEW_CONFIGURATION' | translate) : selectedConfiguration.id }}</h4>
              </div>
              <div class="d-flex align-items-center">
                <span *ngIf="form.dirty" class="badge badge-warning mr-2">{{ 'PFE_UNSAVED' | translate }}</span>
                <button
                  *ngIf="!isNew"
                  type="button"
                  class="btn btn-outline-secondary mr-2"
                  [disabled]="saving || deleting || loading"
                  (click)="copyConfiguration()"
                >
                  <i class="fa fa-copy mr-1" aria-hidden="true"></i>
                  {{ 'COPY' | translate }}
                </button>
                <button
                  *ngIf="!isNew"
                  type="button"
                  class="btn btn-outline-danger mr-2"
                  [disabled]="saving || deleting || loading"
                  (click)="deleteConfiguration()"
                >
                  {{ 'PFE_DELETE' | translate }}
                  <i *ngIf="deleting" class="fa fa-spinner fa-spin ml-2" aria-hidden="true"></i>
                </button>
                <button
                  *ngIf="isNew"
                  type="button"
                  class="btn btn-outline-secondary mr-2"
                  [disabled]="saving"
                  (click)="cancelNew()"
                >
                  {{ 'PFE_CANCEL' | translate }}
                </button>
                <button type="submit" class="btn btn-primary" [disabled]="saving || loading || form.invalid || !form.dirty">
                  {{ 'PFE_SAVE' | translate }}
                  <i *ngIf="saving" class="fa fa-spinner fa-spin ml-2" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>

          <fieldset [disabled]="saving || loading" class="p-3">
            <div *ngIf="saveError" class="alert alert-danger py-2" role="alert">
              {{ saveError }}
            </div>

            <section class="pfe-config-section mb-4">
              <div class="row">
                <div class="col-12 col-md-6">
                  <label for="pfe-config-id" class="small text-muted mb-1">{{ 'ID' | translate }}</label>
                  <input
                    id="pfe-config-id"
                    type="text"
                    class="form-control"
                    formControlName="id"
                    [placeholder]="isNew ? ('PFE_FIELD_ID_PLACEHOLDER' | translate) : ''"
                  />
                  <div *ngIf="form.get('id')?.errors?.duplicateId" class="text-danger small mt-1">
                    {{ 'DUPLICATE' | translate }}
                  </div>
                </div>
              </div>
            </section>

            <section *ngFor="let group of fieldGroups" class="pfe-config-section mb-4">
              <h5 class="pfe-config-section-title">{{ group.title | translate }}</h5>
              <div class="row">
                <div
                  *ngFor="let field of group.fields; trackBy: trackByFieldKey"
                  class="mb-3"
                  [ngClass]="field.type === 'textarea' || field.type === 'array' ? 'col-12' : 'col-12 col-md-6'"
                >
                  <label *ngIf="field.type !== 'boolean'" [for]="'pfe-config-' + field.key" class="small text-muted mb-1">
                    {{ field.label | translate }}
                  </label>

                  <ng-container [ngSwitch]="field.type">
                    <textarea
                      *ngSwitchCase="'textarea'"
                      [id]="'pfe-config-' + field.key"
                      class="form-control"
                      rows="2"
                      [formControlName]="field.key"
                    ></textarea>

                    <textarea
                      *ngSwitchCase="'array'"
                      [id]="'pfe-config-' + field.key"
                      class="form-control pfe-config-array"
                      rows="3"
                      [formControlName]="field.key"
                    ></textarea>

                    <div *ngSwitchCase="'boolean'" class="custom-control custom-checkbox pfe-config-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        [id]="'pfe-config-' + field.key"
                        [formControlName]="field.key"
                      />
                      <label class="custom-control-label" [for]="'pfe-config-' + field.key">{{ field.label | translate }}</label>
                    </div>

                    <input
                      *ngSwitchCase="'number'"
                      [id]="'pfe-config-' + field.key"
                      type="number"
                      class="form-control"
                      [formControlName]="field.key"
                    />

                    <select
                      *ngSwitchCase="'template'"
                      [id]="'pfe-config-' + field.key"
                      class="form-control"
                      [formControlName]="field.key"
                    >
                      <option value="">-</option>
                      <option *ngFor="let template of templates" [value]="template.id">{{ template.name }}</option>
                    </select>

                    <input
                      *ngSwitchDefault
                      [id]="'pfe-config-' + field.key"
                      type="text"
                      class="form-control"
                      [formControlName]="field.key"
                    />
                  </ng-container>
                </div>
              </div>
            </section>

            <section class="pfe-config-section mb-4">
              <h5 class="pfe-config-section-title">{{ 'PFE_SENSITIVE_FTP_FIELDS' | translate }}</h5>
              <div class="row">
                <div *ngFor="let field of sensitiveFields; trackBy: trackByFieldKey" class="col-12 col-md-6 mb-3">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <label [for]="'pfe-config-' + field.key" class="small text-muted mb-0">{{ field.label | translate }}</label>
                    <span *ngIf="hasExistingSensitiveValue(field.key)" class="badge badge-secondary">{{ 'PFE_STORED' | translate }}</span>
                  </div>
                  <input
                    [id]="'pfe-config-' + field.key"
                    type="password"
                    class="form-control"
                    [placeholder]="hasExistingSensitiveValue(field.key) ? ('PFE_STORED_VALUE_PRESERVED' | translate) : ''"
                    [readonly]="form.get(getSensitiveControlName(field.key, 'Clear'))?.value"
                    [formControlName]="getSensitiveControlName(field.key, 'NewValue')"
                  />
                  <div class="custom-control custom-checkbox mt-2">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      [id]="'pfe-config-' + field.key + '-clear'"
                      [formControlName]="getSensitiveControlName(field.key, 'Clear')"
                    />
                    <label class="custom-control-label small" [for]="'pfe-config-' + field.key + '-clear'">
                      {{ 'PFE_CLEAR_SAVED_VALUE' | translate }}
                    </label>
                  </div>
                </div>
              </div>
            </section>

            <section class="pfe-config-section mb-4">
              <h5 class="pfe-config-section-title">{{ 'PFE_INCLUDED_PROPERTIES_TITLE' | translate }}</h5>
              <div class="pfe-filter-rows" formArrayName="includedFilters">
                <div *ngFor="let row of includedFilters.controls; let i = index; trackBy: trackByIndex" [formGroupName]="i" class="row mb-2 align-items-center">
                  <div class="col-12 col-md-4">
                    <input type="text" class="form-control" [placeholder]="'PFE_PROPERTY_KEY_PLACEHOLDER' | translate" formControlName="key" />
                  </div>
                  <div class="col-12 col-md-6">
                    <input type="text" class="form-control" [placeholder]="'PFE_VALUES_PLACEHOLDER' | translate" formControlName="values" />
                  </div>
                  <div class="col-12 col-md-2 text-md-right">
                    <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeFilterRow('includedFilters', i)">
                      {{ 'PFE_REMOVE' | translate }}
                    </button>
                  </div>
                </div>
              </div>
              <button type="button" class="btn btn-outline-secondary btn-sm" (click)="addFilterRow('includedFilters')">
                <i class="fa fa-plus mr-1" aria-hidden="true"></i>
                {{ 'PFE_ADD_PROPERTY_FILTER' | translate }}
              </button>
            </section>

            <section class="pfe-config-section mb-4">
              <h5 class="pfe-config-section-title">{{ 'PFE_EXCLUDED_PROPERTIES_TITLE' | translate }}</h5>
              <div class="pfe-filter-rows" formArrayName="excludedFilters">
                <div *ngFor="let row of excludedFilters.controls; let i = index; trackBy: trackByIndex" [formGroupName]="i" class="row mb-2 align-items-center">
                  <div class="col-12 col-md-4">
                    <input type="text" class="form-control" [placeholder]="'PFE_PROPERTY_KEY_PLACEHOLDER' | translate" formControlName="key" />
                  </div>
                  <div class="col-12 col-md-6">
                    <input type="text" class="form-control" [placeholder]="'PFE_VALUES_PLACEHOLDER' | translate" formControlName="values" />
                  </div>
                  <div class="col-12 col-md-2 text-md-right">
                    <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeFilterRow('excludedFilters', i)">
                      {{ 'PFE_REMOVE' | translate }}
                    </button>
                  </div>
                </div>
              </div>
              <button type="button" class="btn btn-outline-secondary btn-sm" (click)="addFilterRow('excludedFilters')">
                <i class="fa fa-plus mr-1" aria-hidden="true"></i>
                {{ 'PFE_ADD_PROPERTY_FILTER' | translate }}
              </button>
            </section>

            <section class="pfe-config-section mb-2">
              <h5 class="pfe-config-section-title">{{ 'PFE_ADVANCED_PARAMETERS' | translate }}</h5>
              <textarea
                class="form-control pfe-config-array"
                rows="4"
                formControlName="paramsJson"
                placeholder="{}"
              ></textarea>
              <div *ngIf="form.get('paramsJson')?.errors?.invalidJson" class="text-danger small mt-1">
                {{ 'PFE_PARAMS_INVALID_JSON' | translate }}
              </div>
            </section>
          </fieldset>
        </form>
      </div>

      <ng-template #noSelection>
        <div class="pfe-config-empty border p-4 text-center text-muted">
          {{ 'PFE_SELECT_OR_CREATE' | translate }}
        </div>
      </ng-template>
    </div>
  </div>
</div>
